/**
 * Gestion de l'intention "devenir vendeur" à travers le tunnel de connexion.
 *
 * Les CTA vendeur de la page /devenir-createur mènent vers /connexion. L'intention
 * doit survivre à l'aller-retour OAuth Google (on quitte le site puis on revient
 * sur /auth/callback, donc le query param d'origine est perdu) : on la stocke
 * dans sessionStorage, qui persiste sur le même onglet le temps du round-trip.
 */

const INTENT_KEY = "tangig_intent";

/** Mémorise que l'utilisateur veut devenir vendeur. */
export function setSellerIntent() {
  try { sessionStorage.setItem(INTENT_KEY, "seller"); } catch { /* stockage indisponible */ }
}

/** Lit l'intention courante sans l'effacer. */
export function getIntent() {
  try { return sessionStorage.getItem(INTENT_KEY); } catch { return null; }
}

/** Efface l'intention une fois consommée. */
export function clearIntent() {
  try { sessionStorage.removeItem(INTENT_KEY); } catch { /* stockage indisponible */ }
}

/**
 * Destination post-login selon le rôle et l'intention "vendeur".
 * Un acheteur existant venu avec l'intention vendeur est envoyé vers
 * /choisir-role (au lieu de son dashboard) pour confirmer la bascule.
 */
export function resolvePostLoginPath(role) {
  const intent = getIntent();

  if (role === "admin") { clearIntent(); return "/admin"; }
  if (role === "seller") { clearIntent(); return "/vendeur/dashboard"; }

  if (role === "buyer") {
    if (intent === "seller") return "/choisir-role?intent=seller";
    return "/acheteur/dashboard";
  }

  // Nouveau compte, pas encore de rôle.
  return intent === "seller" ? "/choisir-role?intent=seller" : "/choisir-role";
}
